import { IFilterState } from '@/components/ui/filters/store/types';

export const FilterState: IFilterState = {};
